
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-commercial-vehicles/Piaggio/E-Xtra-FX-Max",
      function () {
        return require("private-next-pages/electric-commercial-vehicles/Piaggio/E-Xtra-FX-Max/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-commercial-vehicles/Piaggio/E-Xtra-FX-Max"])
      });
    }
  